import React from 'react';
import { fetchYearlyTransactionReports } from 'apiRequest/transaction-report';
import TransactionReportPageContainer from 'components/TransactionReportPageContainer';

export default function TransactionReportYearly() {
  return (
    <TransactionReportPageContainer fetch={fetchYearlyTransactionReports} />
  );
};
